module.exports = __webpack_public_path__ + "static/media/gif.c6c00094.gif";